import { HeroCarouselSlideDto } from "api"

/** Internal links start with "/" (use NextLink); everything else is external (<a>). */
export const isInternalUrl = (url?: string | null): boolean =>
  !!url && url.startsWith("/")

/** Price block renders only when priceLabel is present (per AC). */
export const hasPriceBlock = (slide: HeroCarouselSlideDto): boolean =>
  !!slide.priceLabel

/** CTA row renders only when at least one CTA is active. */
export const showCtaRow = (slide: HeroCarouselSlideDto): boolean =>
  !!slide.ctaPrimaryActive || !!slide.ctaSecondaryActive

/**
 * How long a slide stays on screen, in seconds (DLK-949).
 *
 * A video slide lasts exactly as long as its video — stretching past the CMS
 * interval for a long video and cutting under it for a short one. The interval
 * is the fallback for image slides, and for the moment before `loadedmetadata`
 * reports a duration.
 *
 * Drives both the nav dot's progress bar and the slide's autoplay delay, so the
 * two cannot drift apart.
 *
 * @param videoDurationSec length of the slide's visible background video.
 *   `undefined` when the slide has no video or metadata hasn't loaded yet; 0 and
 *   the non-finite values a broken file can report fall back the same way.
 * @param autoPlayIntervalSec CMS-configured slide interval.
 */
export const resolveSlideDurationSec = (
  videoDurationSec: number | undefined,
  autoPlayIntervalSec: number
): number =>
  videoDurationSec && Number.isFinite(videoDurationSec)
    ? videoDurationSec
    : autoPlayIntervalSec
